export enum PlatformNames {
    WebPos = 'webPos',
    Ehopper = 'ehopper',
}
